function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1905 46c-22 5-45 7-72 7-118 0-126-46-219-46-94 0-189 46-263 46-17 0-127-52-217-52-185 0-223 50-325 49-50-15-93-49-190-49-124 0-174 52-291 52C210 53 202 7 109 7 72 7 36 14 0 23v164h1905V46z",
  fill: "#239FAF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47 13a507 507 0 0198 1l30 8 29 11a336 336 0 0064 18l34 2C209 46 195 7 109 7c-21 0-42 2-62 6zM496 20a1116 1116 0 0173-12 483 483 0 01144 10l34 10 17 6 8 3 9 3C741 23 697 1 619 1c-50 0-88 9-123 19zM1514 20l8-1 8-1 16-2a586 586 0 0163-5h4l4 1h16l4 1h3c21 2 40 8 59 15l30 11 7 2 4 1 4 1 8 1 8 2c-55-14-77-39-146-39-34 0-67 6-100 13zM1124 6h22a335 335 0 0166 9c29 6 57 14 86 21a540 540 0 00-352-11l44-8a740 740 0 01134-11z",
  fill: "#69BCB8"
});

var SvgSeaWave4 = function SvgSeaWave4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 1905,
    height: 187,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSeaWave4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sea-wave-4.f98e8847.svg";
export { ForwardRef as ReactComponent };